const INITIAL_STATE = {
    accessStatus: { values: [], error: null, loading: false },
  };
  
  export default function (state = INITIAL_STATE, action) {
    return {
      ...state,
      accessStatus: { values: action.payload, error: null, loading: true },
    };
  }
  